export default "__VITE_PUBLIC_ASSET__a29ac112__"